module.exports = __webpack_public_path__ + "assets/img/Fotolia_126960402_XS.49e88175.jpg";